module.exports = __webpack_public_path__ + "static/fea-38cac201c2473499a1bc1074364b78ee.png";